import { render, staticRenderFns } from "./DingDingPastRecords.vue?vue&type=template&id=35cad784&scoped=true"
import script from "./DingDingPastRecords.vue?vue&type=script&lang=js"
export * from "./DingDingPastRecords.vue?vue&type=script&lang=js"
import style0 from "./DingDingPastRecords.vue?vue&type=style&index=0&id=35cad784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cad784",
  null
  
)

export default component.exports